/* internalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./internalComponents.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import * as React from 'react';
export var Fragment = function Fragment(_ref) {
  var forgeDoc = _ref.forgeDoc,
    render = _ref.render;
  return /*#__PURE__*/React.createElement(React.Fragment, null, forgeDoc.children.map(render));
};
export var Root = function Root(_ref2) {
  var forgeDoc = _ref2.forgeDoc,
    render = _ref2.render;
  var children = forgeDoc.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1qhqze3t _1jzaze3t _1bgsze3t _9b1aze3t _cog4ze3t _1gbhze3t"])
  }, children.map(render));
};